import 'whatwg-fetch'; // I.E. fetch polyfill

if (window.NodeList && !NodeList.prototype.forEach) { // I.E. Polyfill, forEach on NodeList
	NodeList.prototype.forEach = Array.prototype.forEach;
}
if (window.HTMLCollection && !HTMLCollection.prototype.forEach) { // I.E. Polyfill, forEach on HTMLCollection
	HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

// Element.matches() polyfill
if (!Element.prototype.matches) {
	Element.prototype.matches =
		Element.prototype.matchesSelector ||
		Element.prototype.mozMatchesSelector ||
		Element.prototype.msMatchesSelector ||
		Element.prototype.oMatchesSelector ||
		Element.prototype.webkitMatchesSelector ||
		function(s) {
			let matches = (this.document || this.ownerDocument).querySelectorAll(s),
				i = matches.length;
			while (--i >= 0 && matches.item(i) !== this) {}
			return i > -1;
		};
}

// Add device-specific classes
if (navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.toLowerCase().indexOf('trident') > -1) {
	document.body.classList.add('is-ie');
}
if (navigator.userAgent.indexOf('Firefox') > -1) {
	document.body.classList.add('is-ff');
}
if (typeof window.ontouchstart !== 'undefined') {
	document.body.classList.add('touch-device');
} else {
	document.body.classList.add('non-touch');
}

const util = {

	'qS': function(sel) {
		if (document.querySelectorAll(sel).length <= 1) {
			return document.querySelector(sel);
		} else {
			return document.querySelectorAll(sel);
		}
	},

	'checkQuery': function(param, refer) {
		var qUrl = '';
        if (typeof refer === 'string') {
            qUrl = refer;
        }
        else {
            qUrl = window.location.href;
        }
        var resRegEx = new RegExp("[?&]" + param + "=([^&#]+)?", "g");
        var query = qUrl.match(resRegEx);
        if (query !== null) {
            query = query[0].split('=')[1];
        }
        return query;
    },
	
	'getIndex': function(elem) {
		var elemArr = new Array();
		elem.parentNode.children.forEach(function(el) {
			elemArr.push(el);
		});
		return elemArr.indexOf(elem);
	},
	
	'getDomain': function(noStaging) {
		var _domain = "";
			if (window.location.host.split('.').length === 4){
				_domain = window.location.host.split('.')[1] + ".";
			}
			if (window.location.host.split('.').length === 5){
				_domain = window.location.host.split('.')[1] + "."+ window.location.host.split('.')[2] + ".";
			}
			if (typeof noStaging != 'undefined') {
				_domain = _domain.replace('staging.','').replace('proddev.','');
			}
			return _domain;
	},
	
	'preLoadImg': function(imgPaths) {
		imgPaths.forEach((url) => {
			let preload = new Image();
			preload.src = url;
		});
	},
	
	'getRandomArr': function(arr, num) {
		let shuffled = arr.slice().sort(() => 0.5 - Math.random());
		let selected = shuffled.slice(0, num);
		return selected;
	},
	
	'getClosest': function (elem, selector) {
		// Get the closest matching parent element
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}
		return null;
	},
	
	'insertAfter': function(newNode, existingNode) {
		existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
	},
	
	'strToDom': function(str) {
		let wrapDiv = document.createElement('div');
		wrapDiv.innerHTML = str;
		return wrapDiv.firstChild;
	},
	
	'wmdPageLink': function(modval, elem) {
		try { wmdPageLink(modval, elem); } catch(e) { console.log(e); }
	}
	
}

export default util;